
import rp211 from "./rp211";
import rp213 from "./rp213";
import rp235 from "./rp235";
import rp219 from "./rp219";
import rp227 from "./rp227";
import rp225 from "./rp225";
import rp226 from "./rp226";
import rp247 from "./rp247";
import rp017 from "./rp017";
import rp250 from "./rp250";
import rp018 from "./rp018";
import rp557 from "./rp557";
import rp243 from "./rp243";
import rp556 from "./rp556";
import rp244 from "./rp244";
import rp246 from "./rp246";
import ddregister from "./ddregister";

export default {
    rp211,
    rp213,
    rp235,
    rp219,
    rp227,
    rp225,
    rp226,
    rp247,
    rp017,
    rp250,
    rp018,
    rp557,
    rp243,
    rp556,
    rp244,
    rp246,
    ddregister
}